import script from "./AgendarCita.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendarCita.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__